export default "__VITE_ASSET__DtPmIuIy__"